import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Card, CardImage } from '@blueprint/card';
import { FeatureList } from '@zoopla/listings/features';
import { CardImagePlaceholder, PropertyImage } from '@zoopla/listings/image';

export const StyledListingCardLandscape = styled(Card)(css`
    display: block;
    padding: 0;
    position: relative;
`);

export const StyledListingCardLandscapeBody = styled('div')(
    ({ theme: { colors } }) => {
        return css`
            align-items: stretch;
            display: flex;
            flex-direction: row;
            height: 14.125rem;
            position: relative;
            border-bottom: 1px solid ${colors['graphic-divider']};

            ${PropertyImage} {
                align-items: center;
                display: flex;
                flex-grow: 0;
                flex-shrink: 0;
                flex-basis: 20rem;
                height: auto;
                justify-content: center;
                position: relative;
                width: 100%;
                text-align: center;
                max-width: 20rem;
                min-height: 13.75rem;

                ${CardImage} {
                    height: 100%;
                    left: 0;
                    margin: 0;
                    min-width: 0;
                    object-fit: cover;
                    object-position: center center;
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 100%;
                }

                ${CardImagePlaceholder} {
                    position: absolute;
                }
            }
        `;
    }
);

export const StyledSavedListingInfo = styled('div')(
    ({ theme: { spacing } }) => css`
        align-items: flex-start;
        display: flex;
        flex: 1 1 100%;
        flex-direction: column;
        padding: ${spacing['16px']};

        ${FeatureList} {
            display: flex;
            flex-direction: row;
            margin-top: ${spacing['16px']};
        }
    `
);

export const SavedListingTitle = styled('p')(
    ({ theme: { colors, fontSizes, fontWeight, type } }) =>
        css`
            margin: 0;
            line-height: ${type.lineHeight};
            color: ${colors['neutral-6']};
            font-size: ${fontSizes[0]};
            font-weight: ${fontWeight.bold};
            text-transform: uppercase;
        `
);

export const SavedListingPrice = styled('p')(
    ({ theme: { fontWeight, spacing, colors } }) => css`
        color: ${colors['text-body']};
        font-size: 1.25rem; /* 20px */
        font-weight: ${fontWeight.bold};
        line-height: 1.4; /* 28px */
        margin: ${spacing['4px']} 0;
    `
);

export const SavedListingAddress = styled('p')(
    ({ theme: { colors, type } }) => css`
        margin: 0;
        line-height: ${type.lineHeight};
        font-size: ${type.body};
        color: ${colors['neutral-6']};
    `
);

export const SavedListingTransportList = styled('ul')(css`
    display: block;
    list-style: none;
    margin: 0;
    padding: 0;
`);

export const SavedListingTransports = styled('li')(
    ({ theme: { spacing } }) => css`
        :first-of-type {
            margin-top: ${spacing['16px']};
        }
    `
);

export const SavedListingLink = styled('a')(
    ({ theme: { focusRing } }) => css`
        display: block;
        text-decoration: none;

        &:focus {
            box-shadow: ${focusRing};
            outline: none;
        }

        ::after {
            bottom: 0;
            content: '';
            left: 0;
            opacity: 0;
            position: absolute;
            right: 0;
            top: 0;
        }
    `
);
